import { useContext } from "react";
import { WizardContext } from "../providers/WizardProvider";

export const useWizard = () => useContext(WizardContext);

